var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _vm.team && !_vm.loading
        ? _c(
            "v-card",
            {
              staticClass: "h-100",
              attrs: {
                elevation: "0",
                outlined: "",
                width: "100%",
                "min-height": "350",
              },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "py-1 white--text d-flex align-center justify-space-between",
                  class: _vm.$vuetify.theme.dark ? "black" : "primary",
                  staticStyle: { "flex-wrap": "nowrap" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center",
                      staticStyle: { flex: "1 1 auto", "min-width": "0" },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "white", medium: "" },
                        },
                        [_vm._v("shield")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                        },
                        [_vm._v(_vm._s(_vm.$t("dashboards.myTeam")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text font-weight-bold pl-0 pr-0",
                      staticStyle: { "flex-shrink": "0" },
                      attrs: { text: "", small: "", to: `/team/${_vm.teamId}` },
                    },
                    [
                      _c("span", { staticClass: "text-decoration-underline" }, [
                        _vm._v(_vm._s(_vm.$t("dashboards.seeMyTeam"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "ml-1",
                          attrs: { small: "", color: "white" },
                        },
                        [_vm._v("keyboard_arrow_right")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "pb-4 px-4 pt-2", attrs: { "no-gutters": "" } },
                [
                  _c("v-col", { attrs: { cols: "12", xl: "8" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: `/team/${_vm.team.teamId}` } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pa-1 d-flex align-center justify-center mr-4",
                                class: {
                                  "grey lighten-3 rounded-lg":
                                    !_vm.$vuetify.theme.dark,
                                  "black lighten-3 rounded-lg":
                                    _vm.$vuetify.theme.dark,
                                },
                                staticStyle: { width: "90px", height: "90px" },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                      _vm.team.teamId +
                                      ".png",
                                    height: _vm.$vuetify.breakpoint.smAndDown
                                      ? "60"
                                      : "80",
                                    contain: "",
                                  },
                                  on: {
                                    error: function ($event) {
                                      return _vm.onImageLoadFailure(
                                        $event,
                                        "team"
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column justify-center" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "text-h6 font-weight-bold primary--text",
                                staticStyle: {
                                  "text-decoration": "none",
                                  "line-height": "1.2",
                                },
                                attrs: { to: `/team/${_vm.team.teamId}` },
                              },
                              [_vm._v(_vm._s(_vm.team.teamName))]
                            ),
                            _vm._v(" "),
                            _vm.team.leagueId && _vm.team.ranking
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center px-2 py-1 rounded mt-1",
                                    class: _vm.$vuetify.theme.dark
                                      ? "black lighten-2"
                                      : "grey lighten-4",
                                    staticStyle: { width: "fit-content" },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "mr-1",
                                      attrs: {
                                        src:
                                          "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/" +
                                          _vm.team.leagueId +
                                          ".png",
                                        height: "14",
                                        contain: "",
                                      },
                                      on: {
                                        error: function ($event) {
                                          return _vm.onImageLoadFailure(
                                            $event,
                                            "league"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "caption font-weight-bold primary--text mr-1",
                                      },
                                      [_vm._v("#" + _vm._s(_vm.team.ranking))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "caption primary--text mr-1",
                                      },
                                      [_vm._v("at")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "caption primary--text mr-1",
                                      },
                                      [_vm._v(_vm._s(_vm.team.leagueName))]
                                    ),
                                    _vm._v(" "),
                                    _vm.team.countryCode
                                      ? _c("DriblabCountryFlag", {
                                          staticClass: "ml-1",
                                          staticStyle: {
                                            width: "14px",
                                            height: "10px",
                                          },
                                          attrs: { iso: _vm.team.countryCode },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.team.elo
                              ? _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          top: "",
                                          color: "lightSecondary lighten-4",
                                          "max-width": "300",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "d-flex align-center rounded py-1 px-2",
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "black lighten-2"
                                                            : "grey lighten-4",
                                                          staticStyle: {
                                                            width:
                                                              "fit-content",
                                                            cursor: "pointer",
                                                          },
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "pa-0 px-2 body-2 font-weight-bold white--text mr-1 monospace-font",
                                                          attrs: {
                                                            "x-small": "",
                                                            color:
                                                              "grey darken-2",
                                                          },
                                                        },
                                                        [_vm._v("ELO")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 text-ellipsis",
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  Math.floor(
                                                                    _vm.team.elo
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.team.diffElo !==
                                                            0 &&
                                                          _vm.team.diffElo !==
                                                            null
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  class: {
                                                                    "success--text":
                                                                      _vm.team
                                                                        .diffElo >
                                                                      0,
                                                                    "error--text":
                                                                      _vm.team
                                                                        .diffElo <
                                                                      0,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        (" +
                                                                      _vm._s(
                                                                        _vm.team
                                                                          .diffElo >
                                                                          0
                                                                          ? "+"
                                                                          : ""
                                                                      ) +
                                                                      _vm._s(
                                                                        Math.floor(
                                                                          _vm
                                                                            .team
                                                                            .diffElo
                                                                        )
                                                                      ) +
                                                                      ")\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2285109944
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-column black--text body-1",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold mb-1",
                                              },
                                              [_vm._v("ELO Rating")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Current: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.floor(_vm.team.elo)
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _vm.team.diffElo !== 0 &&
                                            _vm.team.diffElo !== null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    Change: \n                    "
                                                  ),
                                                  _c(
                                                    "b",
                                                    {
                                                      class:
                                                        _vm.team.diffElo > 0
                                                          ? "success--text"
                                                          : "error--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.team.diffElo > 0
                                                              ? "+"
                                                              : ""
                                                          ) +
                                                          _vm._s(
                                                            Math.floor(
                                                              _vm.team.diffElo
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.team.rankElo
                                              ? _c("span", [
                                                  _vm._v("Rank: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      "#" +
                                                        _vm._s(_vm.team.rankElo)
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.team.diffRankElo !== 0 &&
                                            _vm.team.diffRankElo !== null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    Rank Change: \n                    "
                                                  ),
                                                  _c(
                                                    "b",
                                                    {
                                                      class:
                                                        _vm.team.diffRankElo > 0
                                                          ? "success--text"
                                                          : "error--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.team
                                                              .diffRankElo > 0
                                                              ? "+"
                                                              : ""
                                                          ) +
                                                          _vm._s(
                                                            _vm.team.diffRankElo
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.team.dateEloUpdated
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "mt-1 body-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Updated: " +
                                                        _vm._s(
                                                          _vm.team
                                                            .dateEloUpdated
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "align-self-stretch mt-2",
                      attrs: { cols: "12", xl: "4" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-center align-center pa-2 h-100 rounded-lg",
                          class: {
                            "grey lighten-3 rounded-lg border":
                              !_vm.$vuetify.theme.dark,
                            "black lighten-3 rounded-lg border":
                              _vm.$vuetify.theme.dark,
                          },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: "",
                                color: "lightSecondary lighten-4",
                                "max-width": "300",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text font-weight-bold text-sm-h5 body-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentUserCurrencySymbol
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "px-1 primary--text font-weight-bold monospace-font",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCash")(
                                                      _vm.team.marketValue,
                                                      _vm.currentUserRate
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4197742920
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "black--text body-1" },
                                [_vm._v("Team Market Value")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "mb-3" }),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "px-4 pt-0 pb-4" },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _vm.team.coachName
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pr-3 mb-2",
                              attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-2 primary--text subheader-font",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("team.coach")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-1 font-weight-medium primary--text",
                                  },
                                  [_vm._v(_vm._s(_vm.team.coachName))]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pr-3 mb-2",
                          attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                        },
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 primary--text subheader-font",
                              },
                              [_vm._v(_vm._s(_vm.$t("team.stadium")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium primary--text",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.team.stadiumName
                                        ? _vm.team.stadiumName
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pr-3 mb-2",
                          attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                        },
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 primary--text subheader-font",
                              },
                              [_vm._v(_vm._s(_vm.$t("team.roster")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium primary--text",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.team.squadSize
                                        ? _vm.team.squadSize
                                        : "-"
                                    ) +
                                    " " +
                                    _vm._s(_vm.$t("searchbar.players")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.team.averageAge
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pr-3 mb-2",
                              attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-2 primary--text subheader-font",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("team.averageAge")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-1 font-weight-medium primary--text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.team.averageAge.toFixed(1))
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pr-3 mb-2",
                          attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                        },
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 primary--text subheader-font",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("team.preferredFormation"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium primary--text",
                              },
                              [
                                _vm.team.preferredFormation
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.team.preferredFormation) +
                                          "\n                "
                                      ),
                                      _vm.team.preferredFormationUses
                                        ? _c(
                                            "span",
                                            { staticClass: "ml-1 body-2" },
                                            [
                                              _vm._v(
                                                "\n                  (" +
                                                  _vm._s(
                                                    _vm.team
                                                      .preferredFormationUses
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("general.times")
                                                  ) +
                                                  ")\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : [_vm._v("-")],
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.team.transferBalance !== null &&
                      _vm.team.transferBalance !== undefined
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pr-3 mb-2",
                              attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-2 primary--text subheader-font",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("team.transferBalance"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-1 font-weight-medium primary--text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatCash")(
                                          _vm.team.transferBalance,
                                          _vm.currentUserRate
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pr-3 mb-2",
                          attrs: { cols: "6", sm: "6", md: "4", lg: "3" },
                        },
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 primary--text subheader-font",
                              },
                              [_vm._v(_vm._s(_vm.$t("team.childTeam")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium primary--text",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.team.childName
                                        ? _vm.team.childName
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "v-card",
            {
              staticClass: "d-flex justify-center align-center py-8 px-12",
              attrs: { elevation: "0", outlined: "" },
            },
            [
              _c("v-progress-circular", {
                attrs: { size: 75, color: "secondary", indeterminate: "" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }